function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import LRUCache from "lru-cache";
import db from "./db";
const withCache = (cache, lookupFunction)=>{
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(input) {
            const cachedResult = cache.get(input);
            if (cachedResult) {
                return cachedResult;
            }
            const resolvedResult = yield lookupFunction(input);
            if (resolvedResult) {
                cache.set(input, resolvedResult);
            }
            return resolvedResult;
        });
        return function(input) {
            return _ref.apply(this, arguments);
        };
    }();
};
export const applicationIdCache = new LRUCache(50);
export const applicationIdToOrganizationIdCache = new LRUCache({
    max: 50,
    maxAge: 1000 * 60 * 5
});
const applicationAuthnTokenToApplicationIdCache = new LRUCache({
    max: 50,
    maxAge: 1000 * 60 * 5
});
/**
 * Fetch the application & scopes from
 */ export const applicationIdFromAuthToken = withCache(applicationAuthnTokenToApplicationIdCache, /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*(authnToken) {
        const applicationAuthToken = yield db.applicationAuthenticationToken.findFirst({
            where: {
                token: authnToken
            },
            select: {
                applicationId: true,
                scopes: true
            }
        });
        return applicationAuthToken;
    });
    return function(authnToken) {
        return _ref.apply(this, arguments);
    };
}());
